import produce from 'immer';
import {
  types,
  CityPassState,
  CityPassActionTypes,
  ValidateTicketRequest,
  ValidateTicketResponse,
  ValidateTicketPending,
  ValidateTicketError
} from './types';

// Actions
export const actions = {
  validateTicket: (payload: ValidateTicketRequest['payload']): CityPassActionTypes => ({
    type: types.VALIDATE_TICKET.REQUEST,
    payload
  }),
  removeTicket: (payload: string): CityPassActionTypes => ({
    type: types.REMOVE_TICKET,
    payload
  }),
  resetCityPass: () => ({ type: types.RESET_CITY_PASS }),
  resetAction: () => ({ type: types.RESET_ACTION }),
  setWasAutoReserveTriggered: (payload: boolean): CityPassActionTypes => ({
    type: types.SET_WAS_AUTO_RESERVE_TRIGGERED,
    payload
  })
};

// Initial State
export const initialState: CityPassState = {
  tickets: [],
  action: {
    loading: false,
    success: false,
    error: undefined
  },
  wasAutoReserveTriggered: false
};

// Reducer
export const reducer = (state: CityPassState = initialState, action: CityPassActionTypes): CityPassState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.VALIDATE_TICKET.SUCCESS:
        draft.tickets.push((action as ValidateTicketResponse).payload);
        draft.action.success = true;
        break;
      case types.VALIDATE_TICKET.PENDING:
        draft.action.loading = (action as ValidateTicketPending).payload;
        break;
      case types.VALIDATE_TICKET.ERROR:
        draft.action.error = (action as ValidateTicketError).payload;
        break;
      case types.REMOVE_TICKET:
        draft.tickets = draft.tickets.filter((ticket) => ticket.barcode !== (action as { payload: string }).payload);
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
      case types.RESET_CITY_PASS:
        return initialState;
      case types.SET_WAS_AUTO_RESERVE_TRIGGERED:
        draft.wasAutoReserveTriggered = (action as { payload: boolean }).payload;
        break;
      default:
      // Do nothing
    }
    return draft;
  });
};
